import { Component } from '@angular/core';

@Component({
  selector: 'num-header-description',
  templateUrl: './header-description.component.html',
  styleUrls: ['./header-description.component.scss'],
})
export class HeaderDescriptionComponent {}
